import { render } from "./FeatureUnavailableModal.vue?vue&type=template&id=377f887b"
import script from "./FeatureUnavailableModal.vue?vue&type=script&lang=ts"
export * from "./FeatureUnavailableModal.vue?vue&type=script&lang=ts"
script.render = render

export default script